import { Component, Input } from '@angular/core';
import { FileItem } from '@app/core/services/file.service';
import { DocumentItem } from '@app/services/document.service';
import { AccountingProcessingHead } from '../accounting-processing-head/accounting-processing-head.component';

@Component({
    selector: 'tt-accounting-processing-carousel',
    templateUrl: './accounting-processing-carousel.component.html',
    styleUrls: ['./accounting-processing-carousel.component.css'],
})
export class AccountingProcessingCarouselComponent {
    @Input()
    public params?: AccountingProcessingHead;
}

type AccountingProcessingDocument = DocumentItem & FileItem;
